import { useSignal } from "@preact/signals-react"
import {postSubmit} from "@ui-seeker/utils";

import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants";
import { AdminProductReviewRetailerSelected, adminProductReviewRawTableData } from "../../@signals";


export default function useAdminProductReviewValidateSite() {
	const { showToast } = useToast()
    const isLoading = useSignal(false)
	const optionsSelect = useSignal([])

    const handleSubmitValidateSite = () => showToast.confirm(`Are you sure you want to NOT validate the following selection?`, {
		onSubmit: () => {
			isLoading.value = true
			postSubmit(`${BACKEND_APIS.SKU_MAPPING}/validate-mapping-async`, {
				[AdminProductReviewRetailerSelected.value]: adminProductReviewRawTableData.value.map((row) => row.productID)
			})
            .then(() => showToast.success('Selection data validated'))
            .catch(() => showToast.error())
            .finally(() => isLoading.value = false)
		}
	})

    const handleSetOptionsSelect = (options) => optionsSelect.value = options

	return { 
		optionsSelect: optionsSelect.value,
        isLoading: isLoading.value,
        handleSubmitValidateSite,
        handleSetOptionsSelect
	}
}